import { render } from "./DownloadHistory.vue?vue&type=template&id=629f4c98"
import script from "./DownloadHistory.vue?vue&type=script&lang=js"
export * from "./DownloadHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__